import React from 'react';
import QuestionnaireEvaluation from '../../components/questionnaire-evaluation';
import currency from '../../modules/currency';

const PurchaseDashboard = ({
  viewer: {
    advisor,
    consultPath,
    products,
    activeLoan: { acceptedOffer, downPayment, purchasePrice },
    borrower: { name, email },
    loan: { loanState },
    ...viewer
  },
  actionPipe,
  ...props
}) => {
  const purpose = acceptedOffer ? 'acceptedOffer' : 'purchase';
  const savings = currency.fromNumber((Number(purchasePrice) - Number(downPayment)) * 0.0075, 0);

  return (
    <QuestionnaireEvaluation
      scenario={'Purchase'}
      acceptedOffer={acceptedOffer}
      consultPath={consultPath}
      products={products}
      advisor={advisor}
      name={name}
      email={email}
      state={loanState}
      purpose={purpose}
      viewer={viewer}
      actionPipe={actionPipe}
      reviewItems={[
        'Your rate quote options across multiple lenders.',
        'A comparison of multiple loan products.',
        'An analysis of your best lender fit.'
      ]}
      steps={['Submit Basic Information', 'Schedule a Review Call', 'Receive Your Offers']}
      savings={savings}
      {...props}
    />
  );
};

export default PurchaseDashboard;



// WEBPACK FOOTER //
// ./src/products/purchase/dashboard.js